import React from 'react'

const ApplyNow = () => <section className='fixed inset-0 z-[9999999999999999999999] bg-white p-8'>


<h1 className='text-2xl font-bold text-[#dc3545]'>Whoops, looks like something went wrong.</h1>


</section>

export default ApplyNow